import { useCallback } from 'react';

import { CHART_FIELD } from '@/entities/chart/model/constants';
import useColor from '@/hooks/domain/useColor';
import useTagStore from '@/stores/TagStore';
import { getChartColorByHash } from '@/styles/colors/chartColors';

const useChartColor = (field: ChartFieldDef) => {
  const tagMap = useTagStore((state) => state.tagMap);
  const color = useColor();

  const getLabelColor = useCallback(
    (seg: StringNumberValue): string => {
      const hashKey: string = String(seg) || '';

      switch (field.type) {
        case CHART_FIELD.FEEDBACK_TAG: {
          const tag = tagMap[seg];

          if (!tag) return color.gray500;

          return color.profile[(tag.color - 1 || 0) % color.profile.length];
        }
        case CHART_FIELD.FEEDBACK_SENTIMENT:
        case CHART_FIELD.FEEDBACK_SENTIMENT_DETAIL: {
          return color.sentiment[Number(seg) as keyof typeof color.sentiment];
        }
        default: {
          return getChartColorByHash(hashKey);
        }
      }
    },
    [field.type, tagMap, color],
  );

  return getLabelColor;
};

export default useChartColor;
